/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import ForgotPassword from '../components/common/ForgotPassword';
import AuthLayout from '../components/common/AuthLayout';
import ScrollingColumn from '../components/common/ScrollingColumn';

const ForgotPasswordPage = () => {
	return (
		<AuthLayout
			left={<ForgotPassword />}
			right={
				<>
					<ScrollingColumn direction="up" />
					<ScrollingColumn direction="down" />
					<ScrollingColumn direction="up" />
				</>
			}
		/>
	);
};
export default ForgotPasswordPage;
